<template>
    <a-carousel arrows>
      <template #prevArrow>
        <div class="custom-slick-arrow" style="left: 10px; z-index: 1">
          <img src="@/assets/icons/arrow_back_ios.svg" alt="">
        </div>
      </template>
      <template #nextArrow>
        <div class="custom-slick-arrow" style="right: 10px">
          <img src="@/assets/icons/arrow_forward_ios.svg" alt="">
        </div>
      </template>
      <img src="https://res.cloudinary.com/dyikvzcke/image/upload/v1757717868/post_1_g3vsid.png" alt="" class="bg w-full h-full" />
      <img src="https://res.cloudinary.com/dyikvzcke/image/upload/v1757717873/bg-1_gnpjlf.png" alt="" class="bg w-full h-full" id="" @click="nextLink('https://wa.me/51998247832')"/>
      <img src="https://res.cloudinary.com/dyikvzcke/image/upload/v1757717870/bg-1_1_tr3k9u.png" alt="" class="bg w-full h-full" id="" @click="nextLink('https://wa.me/51998247832')"/>
      <img src="https://res.cloudinary.com/dyikvzcke/image/upload/v1757717869/bg-1_2_lnn5xf.png" alt="" class="bg w-full h-full" id="" />
    </a-carousel>
  </template>

  <script setup>
  
  function nextLink(url) {
    window.open(url, '_blank');
  }
  </script>

  <style scoped>
  /* For demo */
  :deep(.slick-slide) {
    text-align: center;
    height: auto;
    line-height: 160px;
    background: #364d79;
    overflow: hidden;
  }
  
  :deep(.slick-arrow.custom-slick-arrow) {
    width: 18px;
    height: 18px;
    transition: ease all 0.3s;
    filter: drop-shadow(0px 0px 0px rgba(8, 8, 8, 0.562)) ;
    z-index: 1;
  }
  :deep(.slick-arrow.custom-slick-arrow:before) {
    display: none;
  }
  :deep(.slick-arrow.custom-slick-arrow:hover) {
    color: #fff;
    opacity: 0.5;
  }
  
  :deep(.slick-slide h3) {
    color: #fff;
  }

  .slick-arrow.custom-slick-arrow img {
    object-fit: cover;
    width: 100%;
  }

  :deep(.slick-slide div) {
    height: 100%;
  }
  :deep(.slick-slide img) {
    object-fit: cover;
    height: 100%;
  }

  .bg {
    position: relative;
    cursor: pointer;
  }


 
  </style>